/*
 * Ankerprinzip Beziehungscheck (sections/ankerprinzip-quiz.liquid).
 *
 * Rein clientseitig: keine Anmeldung, keine E-Mail-Abfrage, keine Datenbank,
 * kein externer Dienst, kein LLM/API-Call. Antworten leben ausschliesslich
 * im Arbeitsspeicher dieser Custom-Element-Instanz (this.answers) - kein
 * localStorage/sessionStorage/Cookie, keine Persistenz ueber einen Reload
 * hinaus (bewusst, siehe Auftrag: "keine Speicherung persoenlicher
 * Antworten").
 *
 * Fragen/Scoring sind bewusst NICHT hier in JS dupliziert - die 5
 * Fragen-Container und ihre drei Antwort-Buttons (Wert 2/1/0 ueber
 * data-value) stehen bereits vollstaendig im Liquid-Markup der Section.
 * Dieses Skript liest nur Struktur/Werte aus dem DOM und steuert
 * Sichtbarkeit, Fortschritt, Auswahlstatus und Ergebnis-Panel.
 */

if (!customElements.get('anker-quiz')) {
  customElements.define(
    'anker-quiz',
    class AnkerQuiz extends HTMLElement {
      constructor() {
        super();

        this.questions = Array.from(this.querySelectorAll('[data-quiz-question]'));
        this.answers = this.questions.map(() => null);
        this.currentIndex = 0;

        this.stage = this.querySelector('[data-quiz-stage]');
        this.nav = this.querySelector('[data-quiz-nav]');
        this.backButton = this.querySelector('[data-quiz-back]');
        this.nextButton = this.querySelector('[data-quiz-next]');
        this.progressLabel = this.querySelector('[data-quiz-progress-label]');
        this.progressFill = this.querySelector('[data-quiz-progress-fill]');
        this.progressTrack = this.querySelector('[data-quiz-progress-track]');
        this.resultWrap = this.querySelector('[data-quiz-result]');
        this.resultPanels = Array.from(this.querySelectorAll('[data-quiz-result-panel]'));
        this.restartButton = this.querySelector('[data-quiz-restart]');
        this.mainHeading = this.querySelector('[data-quiz-main-heading]');

        if (!this.questions.length || !this.stage || !this.nav || !this.resultWrap) return;

        this.questions.forEach((question) => {
          question.querySelectorAll('[data-quiz-answer]').forEach((button) => {
            button.addEventListener('click', () => this.selectAnswer(question, button));
          });
        });

        if (this.backButton) this.backButton.addEventListener('click', () => this.goBack());
        if (this.nextButton) this.nextButton.addEventListener('click', () => this.goNext());
        if (this.restartButton) this.restartButton.addEventListener('click', () => this.restart());

        this.renderQuestion(0, { focus: false });
      }

      selectAnswer(question, button) {
        const index = this.questions.indexOf(question);
        if (index === -1) return;

        question.querySelectorAll('[data-quiz-answer]').forEach((otherButton) => {
          otherButton.setAttribute('aria-pressed', otherButton === button ? 'true' : 'false');
        });

        this.answers[index] = parseInt(button.dataset.value, 10);
        this.updateNextState();
      }

      updateNextState() {
        if (!this.nextButton) return;
        const answered = this.answers[this.currentIndex] !== null;
        this.nextButton.disabled = !answered;
        this.nextButton.setAttribute('aria-disabled', answered ? 'false' : 'true');
      }

      updateProgress() {
        const total = this.questions.length;
        const current = this.currentIndex + 1;
        if (this.progressLabel) this.progressLabel.textContent = `Frage ${current} von ${total}`;
        if (this.progressFill) this.progressFill.style.width = `${(current / total) * 100}%`;
        if (this.progressTrack) {
          this.progressTrack.setAttribute('aria-valuenow', String(current));
          this.progressTrack.setAttribute('aria-valuemin', '1');
          this.progressTrack.setAttribute('aria-valuemax', String(total));
          this.progressTrack.setAttribute('aria-valuetext', `Frage ${current} von ${total}`);
        }
      }

      renderQuestion(index, { focus = true } = {}) {
        this.questions.forEach((question, questionIndex) => {
          question.hidden = questionIndex !== index;
        });

        if (this.backButton) this.backButton.disabled = index === 0;
        this.updateNextState();
        this.updateProgress();

        if (focus) {
          const title = this.questions[index].querySelector('[data-quiz-question-title]');
          if (title) title.focus();
        }
      }

      goNext() {
        if (this.answers[this.currentIndex] === null) return;

        if (this.currentIndex === this.questions.length - 1) {
          this.finish();
          return;
        }

        this.currentIndex += 1;
        this.renderQuestion(this.currentIndex);
      }

      goBack() {
        if (this.currentIndex === 0) return;
        this.currentIndex -= 1;
        this.renderQuestion(this.currentIndex);
      }

      finish() {
        const total = this.answers.reduce((sum, value) => sum + (value || 0), 0);
        const resultKey = total >= 8 ? 'a' : total >= 5 ? 'b' : 'c';

        this.stage.hidden = true;
        this.nav.hidden = true;
        this.resultWrap.hidden = false;

        this.resultPanels.forEach((panel) => {
          panel.hidden = panel.dataset.quizResultPanel !== resultKey;
        });

        const activePanel = this.resultPanels.find((panel) => panel.dataset.quizResultPanel === resultKey);
        const heading = activePanel && activePanel.querySelector('[data-quiz-result-heading]');
        if (heading) heading.focus();
      }

      restart() {
        this.answers = this.questions.map(() => null);
        this.currentIndex = 0;

        this.questions.forEach((question) => {
          question.querySelectorAll('[data-quiz-answer]').forEach((button) => {
            button.setAttribute('aria-pressed', 'false');
          });
        });

        this.resultWrap.hidden = true;
        this.stage.hidden = false;
        this.nav.hidden = false;

        this.renderQuestion(0, { focus: false });
        if (this.mainHeading) this.mainHeading.focus();
      }
    }
  );
}
